/**
 * @author: dongjing
 * @file: 回答分页数据列表（圈子，团队，标签页面）
 * @Date: 2020-01-06 19:05:31
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-07 14:46:30
 */
import React from 'react';
import './TabAnswerList.less';
import { Spin } from 'antd';
import SFCAnswerTextImage from '@src/features/home/components/SFCAnswerTextImage';
import * as models from '@src/services/model/models';
import config from '@src/utils/config';
import history from '@src/common/history';
import { openTargetBlankPage } from '@src/utils';
import { NoData, SFCPagination } from '..';

export interface ITabAnswerListProps {
  /** 回答数据列表 */
  answerModel: models.PageableResultSingleArticleInfo;
  /** 调用地方 */
  place?: string;
  /** id */
  id?: number;
  /** 加载状态 */
  loading: boolean;
  /** 回答 赞同反对 */
  doAgreeDisagreeHomeAnswer: (
    answerId: number,
    index: number,
    clickedType: string,
    currentType: number
  ) => void;
  /** 更改页码 */
  changePage: (pageNum: number) => void;
  /** 能否删除 */
  canEdit?: boolean;
  /** 删除函数 */
  removeAnswer?: (item: models.AnswerSimpleInfo) => void;
  /** 是否需要置顶功能 */
  pinned?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
}
type Props = ITabAnswerListProps;
const PAGE_SIZE = 10;
export function TabAnswerList(props: Readonly<Props>) {
  const {
    answerModel,
    loading,
    doAgreeDisagreeHomeAnswer,
    changePage,
    canEdit = false,
    removeAnswer,
    pinned = false,
    isAdmin = false
  } = props;

  /** 回答赞同反对 */
  const onAgreeDisagreeAnswer = (data: {
    answerId: number;
    index: number;
    clickedType: string;
    currentType: number;
  }) => {
    const { answerId, index, clickedType, currentType } = data;

    doAgreeDisagreeHomeAnswer(answerId, index, clickedType, currentType);
  };

  /** 打开新页面 */
  const openTargePage = (targetUri: string) => {
    const { enableTargetBlank } = config;

    if (!enableTargetBlank) {
      history.push(targetUri);
    } else {
      openTargetBlankPage(targetUri);
    }
  };
  /** 分页点击 */
  const changePageNum = (pageNum: number) => {
    changePage(pageNum);
  };

  return (
    <div className="common-presenter k-common-tab-answer-list">
      <Spin className="common-presenter k-circle-answer-list" spinning={loading}>
        {answerModel.list &&
          answerModel.list.map((item, index) => {
            item[`isFollowing`] = item[`isFollowing`] || false;
            return (
              <SFCAnswerTextImage
                key={`ans${index}`}
                data={item}
                index={index}
                onAgreeDisagreeAnswer={onAgreeDisagreeAnswer}
                openTargePage={openTargePage}
                showOption={canEdit}
                handleRemove={() => {
                  removeAnswer && removeAnswer(item);
                }}
                isAdmin={isAdmin}
                pinned={pinned}
              />
            );
          })}
        {answerModel.list && answerModel.list.length > 0 ? (
          <SFCPagination
            pageNum={answerModel.pageNum || 1}
            pageSize={answerModel.pageSize || PAGE_SIZE}
            total={answerModel.total || 0}
            onChange={changePageNum}
          />
        ) : (
          <NoData show={true} />
        )}
      </Spin>
    </div>
  );
}

export default TabAnswerList;
